/* Copyright (c) 2017 Backpack Health LLC */

import { authorizedApiRequest } from './ApiRequest';
import ApiErrorModel from '../models/ApiErrorModel';
import { versionCheck } from '../utilities/LocalStorage';
import { appManifest } from '../utilities/appManifest';
import AppUtils from '../utilities/AppUtils';

const SystemService = {
  redirectLink(redirectUid) {
    return authorizedApiRequest('get', `system/redirect/${redirectUid}`)
      .then(res => res.body.data)
      .catch(err => {
        throw new ApiErrorModel(err);
      });
  },

  versionCheck() {
    return authorizedApiRequest('get', 'system/version/check')
      .then(res => {
        const data = res.body.data;
        const lastCheckedVersion = versionCheck.get() === '0' ? appManifest.app_version : versionCheck.get();
        const someChange = data.changes.find(c => c.breaking && AppUtils.isVersionMoreRecent(c.version, lastCheckedVersion));

        return {
          ...data,
          requiresUserReview: !!someChange && someChange.breaking,
        };
      })
      .catch(err => {
        throw new ApiErrorModel(err);
      });
  },
};

export default SystemService;
